import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { Box, FormControl, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import { useService } from './hooks';
import { useRNG } from './provider';

const BodyHeader = () => {
  const { raffleList } = useService();
  const {state, error, isLoading, onDispatch, handleCodeInput, handleRunDraw } = useRNG();

  return (
    <StyledWrap
      sx={{
        width: "100%",
        alignItems: 'center',
        justifyContent: "center"
      }}>
      <Typography fontSize={"20px"} fontWeight={700}>Select Draw:</Typography>
      <FormControl sx={{ mt: '14px', width: '368px' }}>
        <Select
          displayEmpty
          value={state.code}
          onChange={(e) => handleCodeInput(e.target.value)}
          error={error.code}
          sx={{
            height: '76px',
            bgcolor: 'white',
            borderRadius: '15px',
            fontSize: '20px',
            fontWeight: 700,
            textAlign: 'center',
            '& .MuiSelect-select': {
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            },
            '& .MuiSelect-icon': {
              fontSize: '2.5rem',
              right: 12,
            },
          }}
          renderValue={(val) => {
            if (!val) return <Typography color="#aaa" fontSize={20} fontWeight={700}>Select a draw</Typography>;
            const found = raffleList.find((r: any) => r.code === val);
            return <Typography fontSize={20} fontWeight={700}>{found ? `${found.code}` : val}</Typography>;
          }}
        >
          {raffleList.map((raffle: any) => (
            <MenuItem key={raffle.id} value={raffle.code}>
              <Stack>
                <Typography fontSize={14} fontWeight={700}>{raffle.code}</Typography>
                <Typography fontSize={12} color="#6B7280">{raffle.description}</Typography>
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography display={"inline"} mt={2} fontSize={"16px"} fontWeight={700} color="#737374" >
        Number of Entries:{" "}<Typography component="span" 
        fontSize={"22px"} fontWeight={700} color="#0C3ACA">
          {numeral(raffleList.find((r: any) => r.code === state.code)?.totalRedeemedTickets).format("0,000")}
        </Typography>
      </Typography>

      <Stack alignItems={"center"} mt={5}>
        <Typography fontSize={"20px"} fontWeight={700} >Enter Number of Winners Required</Typography>
        <StyledInput
          sx={{
            '& .MuiInputBase-root': {
              width: "368px",
              height: '76px',
              bgcolor: "white",
              borderRadius: "15px"
            },
            "& .MuiOutlinedInput-root": {
              alignItems: "center",
              // padding: "12px 14px",           // 👈 Better paragraph feel
              textAlign: "center",
            },
            "& .MuiOutlinedInput-input": {
              fontSize: "26px",
              lineHeight: "30px",
              fontWeight: 700,
              padding: 0,                     // removes default tight padding
              textAlign: "center",
            },
          }}
          placeholder='00'
          error={error.numWinners}
          value={state.numWinners}
          onChange={(e) => onDispatch("numWinners")(e.target.value)}
        />

      </Stack>
      <StyledButton 
        variant="text"
        disableRipple
        disableElevation
        sx={{
          mt: 4,
          color: "white",
          width: {
            xl: 239,
            lg: 239,
            md: 239,
            sm: "100%",
            xs: "100%",
          },
          height: {
            xl: 53,
            lg: 53,
            md: 53,
            sm: 54,
            xs: 54,
          },
          bgcolor: "purple.dark",
          "&:hover": {
            bgcolor: "purple.main"
          }
        }}
        disabled={_.isEmpty(state.numWinners) || _.isEmpty(state.code)}
        loading={isLoading}
        onClick={handleRunDraw} >
        RUN DRAW
      </StyledButton>
    </StyledWrap>
  );
}

const StyledWrap = styled(Box)({
  // height: 96,
  marginBottom: 93,
  width: "100%",
  display: 'flex',
  flexDirection: "column",
});

export const StyledInput = styled(TextField)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  marginTop: 14,
  width: "368px",
  height: '76px',
}));

const StyledButton = styled(LoadingButton)(({ theme }: any) => ({
  width: 192,
  marginRight: 0,
  display: 'flex',
  color: "white",
  borderRadius: 8,
  backgroundColor: theme.palette.purple.dark,
}));

export default React.memo(BodyHeader);
